/**
 * Sallittu sisäinen polku alkaa yhdellä `/`:lla (EI kahdella —
 * `//evil.com` on selaimissa "protocol-relative URL" joka navigaation
 * yhteydessä menee ulkoiselle hostille), eikä sisällä järkyttäviä
 * skeemoja kuten `javascript:` tai `data:`. Sallitut merkit on rajattu
 * tunnettujen polku- ja querystring-merkkien joukkoon.
 *
 * Ks. security-audit.md F-09.
 */
const INTERNAL_PATH_RE = /^\/(?!\/)[\w\-./?&=#]*$/;

/**
 * Validoi sisäisen redirect-polun. Jos `raw` ei näytä yksitellen
 * sisäiseltä polulta, palautetaan turvallinen oletus `/dashboard`.
 * Käytetään `LoginView`:ssa (`?redirect=`-querystä) ja
 * `NotificationBell`:ssa (backendin tarjoama `n.linkUrl`).
 */
export function safeInternalPath(raw: string | undefined | null): string {
  if (!raw) return "/dashboard";
  return INTERNAL_PATH_RE.test(raw) ? raw : "/dashboard";
}
